import { render } from "./TestimonialTable.vue?vue&type=template&id=6b85354c"
import script from "./TestimonialTable.vue?vue&type=script&lang=js"
export * from "./TestimonialTable.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Programming\\Padmaweb\\client\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__